<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="评价月份" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择评价月份" v-decorator="[ 'evaluationMonth', validatorRules.evaluationMonth]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="评分" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'score', validatorRules.score]" placeholder="请输入评分" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="本月总分" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'monthTotal', validatorRules.monthTotal]" placeholder="请输入本月总分" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="所得分" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'incomeSplitt', validatorRules.incomeSplitt]" placeholder="请输入所得分" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="审批人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'approvedBy', validatorRules.approvedBy]" placeholder="请输入审批人"></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remark', validatorRules.remark]" placeholder="请输入备注"></a-input>
        </a-form-item>
        <a-form-item label="项目id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'projectId', validatorRules.projectId]" placeholder="请输入项目id"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: "BusDailyProjectScoringRecordModal",
    components: { 
      JDate,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          evaluationMonth: {rules: [
          ]},
          score: {rules: [
          ]},
          monthTotal: {rules: [
          ]},
          incomeSplitt: {rules: [
          ]},
          approvedBy: {rules: [
          ]},
          remark: {rules: [
          ]},
          projectId: {rules: [
          ]},
        },
        url: {
          add: "/dailyproject/busDailyProjectScoringRecord/add",
          edit: "/dailyproject/busDailyProjectScoringRecord/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'evaluationMonth','score','monthTotal','incomeSplitt','approvedBy','remark','projectId'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'evaluationMonth','score','monthTotal','incomeSplitt','approvedBy','remark','projectId'))
      },

      
    }
  }
</script>